import type { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { RootPlaceholderComponent } from './root-placeholder.component';

import { batchRoutes } from './routes/batch.routes';

export const routes: Routes = [
  ...batchRoutes,
  // Keep root path available without rendering header in the outlet
  {
    path: '',
    pathMatch: 'full',
    canActivate: [MsalGuard],
    component: RootPlaceholderComponent,
  },
];
